export default __webpack_public_path__ + "static/media/69_desktop.005a81ce.jpg";